(()=>{
let init = (container)=>{

let slider;

if(slider = (document.currentScript ? document.currentScript.parentElement : container).querySelector(".collections-grid__slider")){

let navigation = slider.parentElement.querySelector(".collections-grid__navigation");
let pagination = slider.querySelector(".collections-grid__pagination");

let desktopColumns = Number(slider.dataset.columns);
let mobileColumns = Number(slider.dataset.mobileColumns) || 1;

if(mobileColumns > 4) mobileColumns = 4;

let xl = desktopColumns;
let lg = desktopColumns > 3 ? xl - 1 : xl;
let md = desktopColumns > 2 ? lg - 1 : lg;

let swiper = new Swiper(slider,{
slidesPerView: mobileColumns,
slidesPerGroup: mobileColumns,
spaceBetween: 8,
speed: 800,

mousewheel:{
forceToAxis:true
},

navigation:{
nextEl: navigation.querySelector(".swiper-button-next"),
prevEl: navigation.querySelector(".swiper-button-prev")
},

pagination:{
el: pagination,
type:"custom",
renderCustom:function(swiper,current,total){

let bullets="";

for(let i=1;i<total+1;i++){
if(i==current){
bullets += `<span class="swiper-pagination-bullet swiper-pagination-bullet-active"></span>`;
}else{
bullets += `<span class="swiper-pagination-bullet"></span>`;
}
}

return bullets;

}
},

breakpoints:{
576:{slidesPerView: md,slidesPerGroup: md,spaceBetween:16},
990:{slidesPerView: lg,slidesPerGroup: lg,spaceBetween:16},
1200:{slidesPerView: xl,slidesPerGroup: xl,spaceBetween:16},
1600:{slidesPerView: desktopColumns,slidesPerGroup: desktopColumns,spaceBetween:16}
},

on:{
init:function(){
slider.classList.remove("loading");
}
}

});

}

};

init();

document.addEventListener("shopify:section:load",function(e){
init(e.target);
});

})();